<template>
  <!-- grid-cols-1 grid-cols-2 grid-cols-3 grid-cols-4 grid-cols-5 grid-cols-6 -->
  <!-- col-span-1 col-span-2 col-span-3 col-span-4 col-span-5 col-span-6 -->
  <app-popup-page @wheel.stop>
    <div class="grid" :class="[`grid-cols-${colsNumber}`]">
      <div
        class="col-start-1 row-span-3 row-start-1"
        :class="{ hidden: onlyPackage }"
      />
      <div
        class="mb-2"
        :class="[
          `col-span-${onlyPackage ? 'full' : packagesNumber}`,
          { 'col-start-2': !onlyPackage }
        ]"
      >
        <h1 class="text-center">
          <span class="text-title-sm">Scegli il tuo stile </span
          ><span class="text-title-sm text-primary">Controcorrente:</span>
        </h1>
      </div>
      <div
        v-for="pack in tablePackages"
        :key="`title-${pack.name}`"
        class="rounded-t-2xl p-2 -ml-px text-center border border-brand"
        :class="[`col-span-${onlyPackage ? 'full' : 1}`]"
      >
        <h1 v-text="pack.title" class="text-primary text-3xl" />
      </div>
      <template v-if="onlyPackage">
        <div
          v-for="pack in tablePackages"
          :key="`smallDesc-${pack.name}`"
          class=" flex p-2 -ml-px text-center border border-t-0 border-brand"
          :class="[`col-span-${onlyPackage ? 'full' : 1}`]"
        >
          <p
            v-html="pack.smallDescription"
            class=" mx-auto my-auto text-sm"
          /></div
      ></template>
      <div
        v-for="pack in tablePackages"
        :key="`cta-top-${pack.name}`"
        class="px-2 -ml-px border-l border-r border-brand"
        :class="[`col-span-${onlyPackage ? 'full' : 1}`]"
      >
        <app-cta-button
          cta
          full-width
          :package-id="pack.packageId"
          class="whitespace-nowrap"
          external
          :link="apriContoUrl"
          button-style="brand"
        />
      </div>
      <!-- <div
        class="col-span-full lg:col-span-1 lg:border-r-0 flex col-start-1 px-4 my-auto -ml-px border-r border-brand"
        :class="{ 'border-l border-brand': onlyPackage }"
        v-if="firstPackageHasTrasholds"
      >
        <div class="my-auto">
          <p
            v-text="'Rendimento Lordo Promozionale'"
            class="text-primary font-bold"
          />
          <p
            v-text="
              '*Valido fino al 31/12/2025 su tutte le somme depositate, in base alla giacenza media annua. Dopo, fino allo 0,75% lordo in base alla giacenza media annua e secondo gli scaglioni di importo.'
            "
            class="lg:block text-xs"
          />
          <div class="prose-sm prose">
            <ul class="lg:hidden" v-html="rendimentoAnnuoSmart"></ul>
          </div>
        </div>
      </div> -->
      <!-- <div
        class="lg:grid relative hidden grid-flow-col -ml-px border-r border-brand"
        :class="[`col-span-${packagesNumber}`, { 'border-l': !onlyPackage }]"
        v-if="firstPackageHasTrasholds"
      >
        <div class=" grid w-full h-full px-4">
          <p
            class="border-primary items-center text-center h-full justify-center flex py-1.5 rounded-full text-primary bg-deepWater px-2 my-auto font-bold text-center border rendimento-text"
          >
            <span
              class="inline-block whitespace-pre-wrap"
              v-text="rendimentoAnnuo"
            />
            <span class="bg-primary last:hidden w-2 h-2 mx-2 rounded-full" />
          </p>
        </div>
      </div> -->
      <template v-for="service in services" :key="service.Name">
        <div
          class=" flex col-span-1 col-start-1 px-4 py-2 -ml-px"
          :class="{ 'border-l border-brand': onlyPackage }"
        >
          <div class="my-auto">
            <p v-text="service.Title" class="text-primary font-bold" />
            <p v-text="service.Description" class="text-xs" />
          </div>
        </div>
        <template
          v-for="pack in tablePackages"
          :key="`${service.Title}-${pack.name}`"
        >
          <div
            class="flex px-4 py-2 -ml-px border-r border-brand"
            :class="{ 'border-l': !onlyPackage }"
          >
            <div
              v-if="pack.services[service.Title]"
              class="text-primary flex w-full"
            >
              <div
                class="m-auto text-sm font-bold text-center"
                v-if="pack.services[service.Title].Value"
                v-text="pack.services[service.Title].Value"
              />
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                class=" h-10 m-auto"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <div v-else class="flex w-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class=" h-10 m-auto"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="{2}"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
        </template>
      </template>
      <div />
      <div
        v-for="pack in tablePackages"
        :key="`cta-bottom-${pack.name}`"
        class=" rounded-b-2xl p-2 -ml-px border-b border-l border-r border-brand"
        :class="[`col-span-${onlyPackage ? 'full' : 1}`]"
      >
        <app-cta-button
          cta
          full-width
          :package-id="pack.packageId"
          class="whitespace-nowrap"
          external
          :link="apriContoUrl"
          button-style="brand"
        />
      </div>
    </div>
  </app-popup-page>
</template>

<script>
import { axios } from "@/plugins/axios";
import _ from "lodash";

export default {
  data: () => ({
    packages: Array()
  }),
  computed: {
    onlyPackage() {
      return this.packagesNumber === 1;
    },
    packagesNumber() {
      return this.tablePackages.length;
    },
    colsNumber() {
      return this.packagesNumber + 1;
    },
    services() {
      let services = _.flatMap(this.packages, "Services");

      services = _.filter(_.uniqBy(services, "Name"));
      services = _.sortBy(services, "DisplayIndex");

      return services;
    },
    tablePackages() {
      let list = _.map(this.packages, value => {
        return {
          title: value.Title,
          smallDescription: value.SmallDescription,
          description: value.Description,
          services: _.mapKeys(value.Services, value => {
            return value.Name;
          }),
          packageId: value.PackageId
        };
      });

      list = this.$route.params.packageId
        ? _.find(list, i => i.packageId === this.$route.params.packageId) && [
            _.find(list, i => i.packageId === this.$route.params.packageId)
          ]
        : list;

      return list || Array();
    },
    // Rendimento a 0 confronti
    //rendimentoAnnuo() {
    //  let thresolds =
    //    !_.isEmpty(this.packages) && _.first(this.packages).Thresholds;
    //  thresolds = _.sortBy(thresolds, "ToDeposit");
    //
    //  return _.map(thresolds, item => {
    //    // Arrotonda per difetto ai 1.000 più vicini
    //    const deposit = Math.floor(item.ToDeposit / 1000) * 1000;
    //    const formattedDeposit = deposit.toLocaleString("it-IT");
    //    const returnPerc = item.YearlyLimitedReturnPercentage.toLocaleString(
    //     "it-IT",
    //      {
    //        minimumFractionDigits: 2
    //      }
    //    );
    //    return `${returnPerc}% su giacenze medie annue a partire da ${formattedDeposit}€`;
    //  });
    //}
    // Rendimento a 2 confronti
    // Smart - visualizzazione da telefono
    rendimentoAnnuoSmart() {
      let thresholds =
        !_.isEmpty(this.packages) && _.first(this.packages).Thresholds;

      thresholds = _.sortBy(thresholds, "ToDeposit");

      return _.map(thresholds, (item, index) => {
        const isLast = index + 1 === thresholds.length;
        const isFirst = index === 0;

        let incipit;
        let deposit;

        if (isFirst && !isLast) {
          incipit = `per importi da`;
          deposit = `${Math.floor(
            item.ToDepositStandard - 1
          ).toLocaleString()} € e fino a ${Math.floor(
            thresholds[index + 1].ToDeposit
          ).toLocaleString()} €`;
        } else if (isLast) {
          incipit = "per importi superiori a";
          deposit = `${Math.floor(item.ToDepositStandard).toLocaleString()} €`;
        }

        const percentage = item.YearlyLimitedReturnPercentage.toLocaleString(
          "it-IT",
          {
            minimumFractionDigits: 2
          }
        );
        const suffix = isLast ? "*" : "";

        return `<li>${percentage}% ${incipit} ${deposit}${suffix}</li>`;
      }).join("");
    },
    rendimentoAnnuo() {
      let thresholds =
        !_.isEmpty(this.packages) && _.first(this.packages).Thresholds;
      thresholds = _.sortBy(thresholds, "FromDeposit"); // Ordiniamo correttamente

      return _.map(thresholds, (item, index) => {
        const isLast = item.ToDeposit === null; // Ultimo elemento se ToDeposit è null
        const isFirst = index === 0;

        let incipit;
        let deposit;

        if (isFirst) {
          incipit = `per importi da`;
          deposit = `${Math.floor(
            item.FromDeposit
          ).toLocaleString()} € e fino a ${Math.floor(
            item.ToDeposit
          ).toLocaleString()} €`;
        } else if (isLast) {
          incipit = "per importi superiori a";
          deposit = `${Math.floor(item.FromDeposit).toLocaleString()} €`;
        }

        const percentage = item.YearlyLimitedReturnPercentage.toLocaleString(
          "it-IT",
          {
            minimumFractionDigits: 2
          }
        );
        const suffix = isLast ? "*" : "";

        return `${percentage}% ${incipit} ${deposit}${suffix}`;
      }).join(" - ");
    },
    // Region - rendimento a 3 confronti
    //
    // rendimentoAnnuo() {
    //   let thresolds =
    //     !_.isEmpty(this.packages) && _.first(this.packages).Thresholds;
    //   thresolds = _.sortBy(thresolds, "ToDeposit");
    //   return _.map(thresolds, (item, index) => {
    //     const last = index + 1 === thresolds.length;
    //     const incipit = last ? "test" : "Fino a";
    //     const deposit =
    //       index + 1 === thresolds.length
    //         ? (item.ToDeposit - 1).toLocaleString()
    //         : item.ToDeposit.toLocaleString();
    //     const returnPerc = item.YearlyLimitedReturnPercentage.toLocaleString(
    //       "it-IT",
    //       {
    //         minimumFractionDigits: 2
    //       }
    //     );
    //     return `${incipit} ${deposit}€: ${returnPerc}%`;
    //   });
    // },
    // comboRednimento() {
    //   const modifiedResults = this.rendimentoAnnuo
    //     .slice(0, 2)
    //     .map((string, index) => {
    //       if (index === 0) {
    //         return string
    //           .replace(/^Fino a/, "Oltre")
    //           .replace(/\s*:\s*[^ ]+$/, "");
    //       } else if (index === 1) {
    //         return string.replace(/^Fino a/, "");
    //       }
    //       return string;
    //     });

    //   return modifiedResults.join(" fino a");
    // }
    // end region
    firstPackageHasTrasholds() {
      return (
        !_.isEmpty(this.packages) &&
        _.some(_.get(_.first(this.packages), "Thresholds"))
      );
    }
  },
  async beforeRouteEnter(to, from, next) {
    let page = Object();
    let packages = Array();
    try {
      packages = await axios.get(process.env.VUE_APP_PLUGIN_PACKAGE_API);
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = page || Object();
      packages = packages || Array();
    } finally {
      next(vm => {
        vm.page = page.data || Object();
        vm.packages = _.get(packages, "data.data.value") || Array();
      });
    }
  }
};
</script>

<style lang="postcss" scoped vars="{ packagesNumber }">
.grid--packages {
  grid-template-columns: 1fr repeat(
      var(--packagesNumber),
      minmax(0, min-content)
    );
}
.rendimento-text {
  font-size: 14px;
}
</style>
